import { readLocalStorage, writeLocalStorage } from 'redux/saga/helpers/local-storage';
import { ADD_BANNER, REMOVE_BANNERS } from './Banners.reducer';

const LS_KEY = 'suppressedReactBanners';

export function bannerMiddleware(
  onClient = __CLIENT__,
  { read, write } = { read: readLocalStorage, write: writeLocalStorage }
) {
  return ({ dispatch, getState }) => next => action => {
    if (typeof action === 'function') {
      return action(dispatch, getState);
    }

    if (action.type === ADD_BANNER && action.data.options.suppressible) {
      if (onClient) {
        const { suppressible } = action.data.options;
        const data = read(LS_KEY, {});

        if (!data[action.data.id]) {
          return next(action);
        }
        if (typeof suppressible === 'number' && Date.now() - suppressible > data[action.data.id]) {
          return next(action);
        }
      }
    } else if (action.type === REMOVE_BANNERS && onClient) {
      const { banners } = getState();
      write(
        LS_KEY,
        action.data
          .map(bannerId => banners.find(banner => banner.id === bannerId))
          .filter(x => x && x.suppressible)
          .map(banner => banner.id)
          .reduce(
            (acc, bannerId) =>
              Object.assign(acc, {
                [bannerId]: Date.now(),
              }),
            read(LS_KEY, {})
          )
      );
      next(action);
    } else {
      next(action);
    }
  };
}
